import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export interface CSOMembersFilterParams {
  thematic_area?: string;
  location?: string;
}

export const csoApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getCSOMembers: build.query<any, CSOMembersFilterParams | void>({
      query: (params) => ({
        url: appEndpoint.getCSOMembers,
        method: 'get',
        params: params || {},
      }),
      providesTags: ['CSOMembers'],
    }),
    addCSOMember: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addCSOMember,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["CSOMembers"] : []),
    }),
    updateCSOMember: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateCSOMember}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["CSOMembers"] : []),
    }),
    deleteCSOMember: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteCSOMember}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['CSOMembers'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCSOMembersQuery,
  useAddCSOMemberMutation,
  useUpdateCSOMemberMutation,
  useDeleteCSOMemberMutation
} = csoApi;
